import utils from 'utils';

import {useEffect, useState} from 'react';

import {UiButton, UiPopover, UiTextInput} from '@components/export';
import {useLabel, useUiPopover} from '@/hooks/export';

export const DetailNote = (props: {
    note: string,
    hideLabel?: boolean,
    disabled?: boolean,
    popupOrigin?: {
        anchorOrigin: any,
        transformOrigin: any,
    },

    onUpdate: (value: string) => void,
}) => {
    const popoverData = useUiPopover();
    const label = useLabel();

    const [orderNote, setOrderNote] = useState(props.note);

    useEffect(() => {
        setOrderNote(props.note);
    }, [props.note]);

    return <div className={cmpClass}>
        <UiButton
            style={props.note ? 6 : 2}
            text={!props.hideLabel ? label.note : ''}
            icon={'iconfa-note'}
            onClick={(e) => {
                popoverData.handleClick(e);
            }}
            disabled={props.disabled}
        />

        <UiPopover
            anchorEl={popoverData.anchorEl}
            setAnchorEl={popoverData.setAnchorEl}
            anchorOrigin={props.popupOrigin?.anchorOrigin}
            transformOrigin={props.popupOrigin?.transformOrigin}
        >
            <div className={classMap.popover}>
                <div className={classMap.input}>
                    <UiTextInput
                        placeholder={label.note}
                        multiline
                        minRows={5}
                        fullWidth
                        value={orderNote}
                        size={'small'}
                        onChange={(e) => setOrderNote(e.target.value)}
                    />
                </div>
                <div className={classMap.actions}>
                    <div>
                        <UiButton
                            style={5}
                            icon={'iconfas-xtrash'}
                            onClick={() => {
                                setOrderNote('');
                                props.onUpdate('');
                                popoverData.handleClose();
                            }}
                        />
                    </div>
                    <div>

                        <UiButton
                            style={3}
                            icon={'iconfa-close'}
                            onClick={() => {
                                setOrderNote(props.note);
                                popoverData.handleClose();
                            }}
                        />
                        <UiButton
                            style={2}
                            icon={'iconfa-save'}
                            onClick={() => {
                                props.onUpdate(orderNote);
                                popoverData.handleClose();
                            }}
                        />
                    </div>
                </div>
            </div>
        </UiPopover>
    </div>;
};

const cmpClass = 'detail-note';
const classMap = utils.generateClassMap(cmpClass, {
    // note: 'note',
    text: 'text',
    popover: 'popover',
    input: 'input',
    actions: 'actions',
    actionsLeft: 'actions--left',
    actionsRight: 'actions--right',
});
